module.exports = __webpack_public_path__ + "assets/img/73@3x.4fce84ca.png";